var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-tab-content-wrapper"},[_c('v-virtual-scroll',{attrs:{"items":_vm.items,"item-height":98,"height":_vm.items.length < 4 ? _vm.items.length * 98 : 4 * 98},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('mailbox-item',{attrs:{"item":item,"is-request":_vm.isRequests,"use-sent-date":"false"},on:{"click":_vm.itemClicked}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }